import { CorporateCardConnection } from '@revenuemarket/bank';

import { API } from '~apis/axios/instance';
import { ResponseBase } from '~types/response';

export interface GetCorporateCardConnectionsResponse extends ResponseBase {
  data: {
    showNudge: boolean;
    connections: CorporateCardConnection[];
  };
}

/*
  Get corporate card connections

  @param companyId
 */
export default function getCorporateCardConnections(companyId: string) {
  return API.get<GetCorporateCardConnectionsResponse>(
    `/api/v2/companies/${companyId}/corporate-cards/connection`,
  );
}
